/**
 * 2022-01-12
 * 文本模版组件 TextModule
 */

import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

const defaultStyle = {
    textAlign: 'left',
    width: 'auto',
    backColor: 'transparent',
    margin: 0,
    iconPosition: 'left',
    iconWidth: '.24rem',
    iconHeight: '.24rem',
    iconSize: '.24rem',
    iconMargin: '.48rem',
    wordSpacing: 'normal',
    opacity: 1,
    fontFamily: '',
};

const textTypeStyle: any = {
    ll: {
        lineHeight: '0.56rem',
        fontSize: '0.48rem',
        color: '#03060b',
        fontClass: 'font-family-extrabold',
        fontFamily: 'var(--font-family-ExtraBold)',
        padding: '0 .25rem',
    },
    lm: {
        lineHeight: '0.44rem',
        fontSize: '0.36rem',
        color: '#03060b',
        fontClass: 'font-family-bold',
        fontFamily: 'var(--font-family-ExtraBold)',
        padding: '0 .45rem',
    },
    ls: {
        lineHeight: '0.32rem',
        fontSize: '0.24rem',
        color: '#03060b',
        fontClass: 'font-family-extrabold',
        fontFamily: 'var(--font-family-ExtraBold)',
        padding: '0 .45rem',
    },
    mm: {
        lineHeight: '0.2rem',
        fontSize: '0.16rem',
        color: '#03060b',
        fontClass: 'font-family-semibold',
        fontFamily: 'var(--font-family-SemiBold)',
        padding: '0 .45rem',
    },
    sl: {
        lineHeight: '0.22rem',
        fontSize: '0.14rem',
        color: 'rgb(34,34,34)',
        fontClass: 'font-family-medium',
        fontFamily: 'var(--font-family-Medium)',
        padding: '0 .45rem',
    },
    ss: {
        lineHeight: '0.16rem',
        fontSize: '0.12rem',
        color: 'rgb(145,145,145)',
        fontClass: 'font-family-medium',
        fontFamily: 'var(--font-family-Medium)',
        padding: '0 .45rem',
    },
};

const defaultData = {
    type: 'mm',
    text: 'Power pretty much anything',
    icon: '',
};

/**
 * style样式参数 和 data数据参数
 * * @param cssStyle{
 *  textAlign: 文本对齐方式 string,
 *  width: 文本长度 string,
 *  backColor: 背景颜色 string,
 *  margin: margin string,
 *  lineHeight: 行高 string,
 *  fontSize: 字体大小 string,
 *  color: 文字颜色 string,
 *  fontFamily: 粗体大小 string|number
 *  iconPosition: icon相对文本位置 // left，right
 *  iconWidth: icon图标宽 number,
 *  iconHeight: icon图标高 number,
 *  iconMargin: icon图标margin string,
 *  wordSpacing: 文本字符间距 string,
 *  opacity: 文字透明度 number,
 *  fontClass: 自带fontFamily和fontWeight的全局class string,
 * }
 * @param data{
 *  type: 文本类型 string //=> ll, lm, ls, mm, sl, sm, ss七类
 *  text: 文本内容 string
 *  icon: icon图标url string // 空字符串则不显示
 * }
 */

export default function TextModule({ cssStyle, data }: any) {
    const dataObj = { ...defaultData, ...data };
    const styles = { ...defaultStyle, ...textTypeStyle[dataObj.type], ...cssStyle };
    const { useEffect, useState } = useGlobal();
    const [isIos, setIsIos] = useState(false);
    useEffect(() => {
        const app = navigator.userAgent;
        setIsIos(/Mac OS X/gi.test(app));
    }, []);
    return (
        <div
            className={`${css.textModule} textModule`}
            style={{
                background: styles.backColor,
                padding: styles.padding,
                display: dataObj.text ? 'block' : 'none',
            }}
        >
            <div
                className="TextModule-in1"
                style={{
                    width: styles.width,
                    textAlign: styles.textAlign,
                    margin: styles.margin,
                    padding: dataObj.icon === '' ? '0' : styles.iconPosition === 'left' ? `0 0 0 ${styles.iconMargin}` : `0 ${styles.iconMargin} 0 0`,
                }}
            >
                <span className={`textBox ${styles.fontClass}`}>
                    {dataObj.icon && styles.iconPosition === 'left' ? (
                        <span className="icons iconsLeft" style={{ fontSize: styles.iconSize, left: `-${styles.iconMargin}` }}>
                            {dataObj.icon}
                        </span>
                    ) : (
                        ''
                    )}
                    <span
                        className={`text ${isIos ? 'iphone-text' : ''}`}
                        style={{
                            color: styles.color,
                            lineHeight: styles.lineHeight,
                            fontWeight: styles.fontWeight,
                            fontSize: styles.fontSize,
                            fontFamily: styles.fontFamily,
                            wordSpacing: styles.wordSpacing,
                            opacity: styles.opacity,
                        }}
                    >
                        {dataObj.text}
                    </span>
                    {dataObj.icon && styles.iconPosition === 'right' ? (
                        <span className="icons iconsRight" style={{ fontSize: styles.iconSize, right: `-${styles.iconMargin}` }}>
                            {dataObj.icon}
                        </span>
                    ) : (
                        ''
                    )}
                </span>
            </div>
        </div>
    );
}
